import {
	Component,
	OnDestroy,
	Input,
	AfterViewInit,
	ViewChild
} from "@angular/core";

import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-caption",
	template: `
		<div
			[id]="id"
			[ngClass]="divClassGen()"
			class="rbc-caption">

			<ng-container *ngIf="link; else spanContent">
				<a
					*ngIf="image || icon || avatarText"
					[id]="id+'ImageAvatar'"
					[attr.aria-label]="title + ' link'"
					[ngClass]="{ 'rbc-caption-avatar-link': link }"
					[href]="link">

					<div
						[attr.aria-label]="imageText"
						[ngClass]="ClassGen"
						[ngStyle]="{ 'background-image': image ? 'url('+image+')' : null }"
						class="rbc-caption-avatar"
					>
						<rbc-icon
							*ngIf="icon && !image"
							[fixedWidth]="true"
							[icon]="icon"
							[size]="iconSize"
							[type]="iconWeight"
							class="rbc-caption-avatar-icon"
						></rbc-icon>
						<span
							*ngIf="avatarText && !image"
							class="rbc-caption-avatar-text">
							{{ avatarText }}
						</span>
					</div>
				</a>
			</ng-container>
			<ng-template #spanContent>
				<span
					*ngIf="image || icon || avatarText"
					[id]="id+'ImageAvatar'"
					[attr.aria-label]="title"
					[ngClass]="{ 'rbc-caption-avatar-link': link }">
					<div
						[attr.aria-label]="imageText"
						[ngClass]="ClassGen"
						[ngStyle]="{ 'background-image': image ? 'url('+image+')' : null }"
						class="rbc-caption-avatar"
					>
					<rbc-icon
							*ngIf="icon && !image"
							[fixedWidth]="true"
							[icon]="icon"
							[size]="iconSize"
							[type]="iconWeight"
							class="rbc-caption-avatar-icon"
						></rbc-icon>
						<span
							*ngIf="avatarText && !image"
							class="rbc-caption-avatar-text">
							{{ avatarText }}
						</span>
					</div>
				</span>
			</ng-template>
			<div
			*ngIf="title || text || linkLabel || defaultContentPresent"
			class="rbc-caption-content">
				<ng-container *ngIf="link; else spanContent2">
					<a
						*ngIf="title"
						[id]="id+'Title'"
						[href]="link"
						class="rbc-caption-title">
						<ng-container
							*ngTemplateOutlet="headerSlot">
						</ng-container>
					</a>
				</ng-container>
				<ng-template #spanContent2>
					<span
						*ngIf="title"
						[id]="id+'Title'"
						class="rbc-caption-title">
						<ng-container
							*ngTemplateOutlet="headerSlot">
						</ng-container>
					</span>
				</ng-template>
				<span *ngIf="text || defaultContentPresent"
					[id]="id+'text'"
					[ngClass]="{'rbc-caption-text-small': textSize === 'small'}"
					class="rbc-caption-text">
					<slot #default><ng-content></ng-content></slot>
					<ng-container *ngIf="default.children.length == 0 && text">
						{{ text }}
					</ng-container>
				</span>



				<ng-container *ngIf="linkLabel">
					<!-- if routerTo is set -->
					<a
						*ngIf="routerTo; else other"
						[ngClass]="{
							'rbc-caption-text-small': textSize === 'small'
						}"
						[routerLink]="routerTo"
						class="rbc-caption-link link-chev"
					>
						{{ linkLabel }} <rbc-icon icon="angle-right"></rbc-icon>
					</a>
					<!-- if routerTo not set -->
					<ng-template #other>
						<a
							[ngClass]="{
								'rbc-caption-text-small':
									textSize === 'small'
							}"
							[href]="link"
							class="rbc-caption-link link-chev"
						>
							{{ linkLabel }} <rbc-icon icon="angle-right" ></rbc-icon>
						</a>
					</ng-template>
				</ng-container>
			</div>
		</div>

		<!-------------- TEMPLATES ------------------->
		<!-- Header slot with default text content -->
		<ng-template #headerSlot>
			<ng-content select="[header]"></ng-content>
			<ng-container *ngIf="title">
				{{ title }}
			</ng-container>
		</ng-template>
	`,
	styles: []
})
export class CaptionComponent implements OnDestroy, AfterViewInit {
	@Input() avatarAlign: "top" | "center" = "center";
	@Input() avatarColor: string;
	@Input() avatarSize: "small" | "medium" | "large" | "xlarge" | "xxlarge" =
		"small";
	@Input() avatarText: string;
	@Input() avatarTextColor: string;
	@Input() circle = true;
	@Input() icon: string;
	@Input() iconSize:
		| ""
		| "xs"
		| "sm"
		| "normal-size"
		| "lg"
		| "2x"
		| "3x"
		| "5x"
		| "7x"
		| "10x" = "normal-size";
	@Input() iconWeight: "solid" | "regular" | "light" = "regular";
	@Input() id: string;
	@Input() image: string;
	@Input() imageText: string;
	@Input() link: string;
	@Input() linkLabel: string;
	@Input() routerTo: string;
	@Input() text: string;
	@Input() textSize: "small" | "regular" = "small";
	@Input() title: string;
	@Input() avatarClass: string;

	// @ViewChild("headerText", { static: false }) $headerContent;
	@ViewChild("default", { static: false }) $defaultContent;

	defaultContentPresent = true;
	headerContentPresent = true;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (this.$defaultContent.nativeElement.childElementCount > 0) {
				this.defaultContentPresent = true;
			}
		}, 10);
	}

	get ClassGen() {
		let color = this.avatarTextColor
			? this.avatarTextColor
			: this.avatarColor
				? "white"
				: null;

		return {
			"rbc-caption-avatar-circle": this.circle,
			"b-transparent": !this.circle,
			[`rbc-caption-avatar-${this.avatarSize}`]:
				this.avatarSize === "small" ||
				this.avatarSize === "large" ||
				this.avatarSize === "xlarge" ||
				this.avatarSize === "xxlarge",
			[`b-${this.avatarColor}`]: this.avatarColor,
			[`c-${color}`]: color
		};
	}

	divClassGen() {
		const classes = {};

		classes["rbc-caption-full"] = this.title || this.text || this.linkLabel || this.defaultContentPresent;
		classes["rbc-caption-align-top"] = this.avatarAlign === "top";
		classes[this.avatarClass] = this.avatarClass;
		return classes;
	}
}
